import styled, { css } from 'styled-components';
import theme from '../../theme';

export const PageContainer = styled.div`
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 2rem;
  background-color: #F5F5F5;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
`;

export const ContentWrapper = styled.div`
  margin-left: 200px;
  padding: 2rem;
  width: calc(100% - 200px);
  box-sizing: border-box;

  @media (max-width: 768px) {
    margin-left: 0;
    padding: 1rem;
    width: 100%;
  }
`;

export const Header = styled.div`
  position: fixed;
  top: 1rem;
  left: -2rem;
  z-index: 10;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  @media (max-width: 768px) {
    width: 100%;
    height: auto;
    flex-direction: row;
    border-radius: 0;
    justify-content: space-around;
    bottom: 0;
    top: auto;
  }
`;

export const Logo = styled.img`
  height: 4rem;
  margin-right: 1rem;
`;

export const MenuContainer = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 180px;
  height: 100vh;
  padding: 0.5rem 0;
  flex-shrink: 0;
  border-radius: 0 10px 10px 0;
  border: 1px solid #E6E6E6;
  border-left: none;
  background: #FFF;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  z-index: 10;
`;

export const MenuButton = styled.button`
  width: 38px;
  height: 38px;
  flex-shrink: 0;
  border-radius: 50%;
  border: none;
  background: ${props => props.isActive ? theme.colors.bleu_fonce : 'transparent'};
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease;
  margin: 0.15rem 0;
  position: relative;
  align-self: flex-start;
  margin-left: 0.5rem;

  @media (max-width: 768px) {
    margin: 0;
    align-self: center;
  }

  &:hover {
    background: ${props => props.isActive ? theme.colors.bleu_fonce : '#f5f5f5'};
  }

  img {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    aspect-ratio: 1/1;
    object-fit: contain;
    position: relative;
    top: 0;
    transition: top 0.1s ease;

    ${props => props.isActive && css`
      &[alt="Profile"] {
        top: 1px;
      }
    `}

    &[alt="Profile"] {
      width: 24px;
      height: 24px;
    }
  }
`;

export const ButtonText = styled.span`
  position: absolute;
  left: 50px;
  color: ${props => props.isActive ? theme.colors.white : theme.colors.noir};
  font-size: ${theme.fontSizes.small};
  white-space: nowrap;
  opacity: 1;
  transition: color 0.3s ease;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const MenuRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0.1rem 0;
  transition: background-color 0.3s ease;
  border-radius: 0 30px 30px 0;
  background-color: ${props => props.isActive ? theme.colors.bleu_fonce : 'transparent'};
  cursor: pointer;

  &:hover {
    background-color: ${props => props.isActive ? theme.colors.bleu_fonce : '#f5f5f5'};
  }

  @media (max-width: 768px) {
    flex-direction: column;
    width: auto;
    border-radius: 10px;
    padding: 0.5rem;
  }
`; 